<template>
  <DoRight
    ref="right"
    :reportId="reportId"
    :scantron="scantron"
    :answer="answer"
    :current="current"
    :allowPause="false"
    storeKey="homework-seconds"
    :hasNotSupport="false"
    shotAnswerEditable
    :submitTopicFunc="submitTopic"
    @getTopic="onGetTopic"
    @submit="onSubmit"
  ></DoRight>
</template>
<script>
import DoRight from "@/components/ques/DoRight.vue";
export default {
  name: "HomeworkDoRight",
  components: {
    DoRight
  },
  props: {
    reportId: {},
    scantron: {
      type: Object,
      default: () => {}
    },
    answer: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerImg: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      current: {}
    };
  },
  computed: {
    total() {
      return this.scantron.list.length;
    },
    answerCount() {
      return this.scantron.list.filter(q => q.status == 1 || q.status == 2)
        .length;
    }
  },
  methods: {
    init(index) {
      this.$refs.right.init(index);
    },
    async onGetTopic({ reportId, index }) {
      let data = await this.$http.post("/api/app/user/homework/question", {
        report_id: reportId,
        page: index
      });
      let ques = data.list[0];
      if (ques.ques_type != 5 && typeof ques.ques_option === "string") {
        ques.ques_option = JSON.parse(ques.ques_option);
      }
      ques.question_id = ques.ques_id;
      ques.index = index;
      this.current = ques;
      this.$emit("topicChange", ques);
    },
    async submitTopic({
      report_id,
      question_id,
      user_answer,
      answer_time,
      question
    }) {
      if (question.ques_type == 5) {
        if (
          user_answer != "" ||
          (this.answerImg[question_id] &&
            this.answerImg[question_id].length > 0)
        ) {
          user_answer = JSON.stringify({
            content: user_answer,
            images: this.answerImg[question_id] || []
          });
        }
      }
      await this.$http.post("/api/app/user/homework/storeQuestion", {
        report_id: report_id,
        question_id: question_id,
        user_answer: user_answer,
        answer_time: answer_time
      });
    },
    async onSubmit({ id, answer_time, autoSubmit }) {
      await this.$http.post("/api/app/user/homework/storeReport", {
        report_id: id,
        answer_time: answer_time
      });

      this.$emit("submit", { autoSubmit });
    },
    async navNext() {
      this.$refs.right.navNext();
    }
  }
};
</script>